import React from 'react'
import { observer } from 'mobx-react'
import Button from '../../components/Button'
import HOME from '../../routing/paths'
import { useHistory } from 'react-router-dom'
import { useQuery } from '../../../lib/hooks/useQuery'

const MaintenanceMode = () => {
  const history = useHistory()
  const query = useQuery()
  const phone = query.get('phone')

  function handleClick () {
    history.push(HOME)
  }

  return (
    <>
    <div className="flex bg-maintenance-400 rounded-lg p-3.5 mb-5">
      <div className="flex flex-col w-full">
        <div className="flex gap-3 pb-3">
          <svg width="20" height="20" viewBox="0 -3 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 7.5V9.16667M10 12.5H10.0084M4.22653 15.8333H15.7735C17.0565 15.8333 17.8584 14.4444 17.2169 13.3333L11.4434 3.33333C10.8019 2.22222 9.19815 2.22222 8.55665 3.33333L2.78315 13.3333C2.14165 14.4444 2.94353 15.8333 4.22653 15.8333Z" stroke="#D38C00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="font-bold"> System is in maintenance mode</span>
        </div>
        <div className="flex justify-between">
          <span>Currently we cannot load any cases for this operation. We will be back online shortly. {phone && `You can contact us at ${phone}`}</span>
        </div>
      </div>
    </div>
    <Button as="a" onClick={handleClick}>
        Back to home
    </Button>
    </>
  )
}

export default observer(MaintenanceMode)
